/**
 * Dashboard Header Component
 * Displays welcome message with user name and print button
 */

import { useLoggedInMember } from "@/modules/auth/states";
import { Printer } from "lucide-react";

export const DashboardHeader = () => {
  const member = useLoggedInMember();

  // Extract first name from full name
  const firstName = member?.name?.split(" ")[0] || "User";

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row items-start gap-1">
        <h1 className="flex-1 font-inter font-semibold text-base leading-6 text-[#0F172B]">
          Welcome back, {firstName}
        </h1>
        <button
          type="button"
          onClick={handlePrint}
          className="flex items-center justify-center w-8 h-6 bg-white border border-[#006FEE] rounded-md hover:bg-[#006FEE]/5 transition-colors"
        >
          <Printer size={16} className="text-[#006FEE]" />
        </button>
      </div>
      <p className="font-inter font-normal text-xs leading-5 text-[#62748E]">
        Real-time visibility into third-party risk posture, critical findings, and priority actions.
      </p>
    </div>
  );
};

export default DashboardHeader;
